<input
  type="number"
  [step]="step"
  [min]="min"
  [max]="max"
  [ngModel]="innerValue"
  [disabled]="disabled"
  (ngModelChange)="handleChange($event)"
  (blur)="handleBlur()"
  class="form-control"
/>
